import React, { useEffect, useState } from 'react';
import Axios from 'axios';
import { v4 as uuid } from 'uuid';
import { Form, FormGroup, Label, Input, Button, FormFeedback } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faArrowLeft, faTrash } from '@fortawesome/free-solid-svg-icons';
import { toast } from 'react-toastify';

import TextFieldGroup from '../../Common/TextFieldGroup';
import SelectFieldGroup from '../../Common/SelectFieldGroup';
import ProgressIndicator from '../../Common/ProgressIndicator';

import { TaskRegistration } from '../../../Data/Classes';
import { registrationStateToString } from '../../../Utils/Converters';

function TaskRegistrationEditForm(props) {
    const [isProgress, setIsProgress] = useState(false);
    const [error, setError] = useState({});
    const [taskReg, setTaskReg] = useState(props.taskReg);
    const [users, setUsers] = useState([]);
    const [searchValue, setSearchValue] = useState(props.taskReg.userName);
    const [usersVisible, setUsersVisible] = useState(false);
    const eventId = props.eventId;

    useEffect(() => {
        getUsers();
    }, [usersVisible, searchValue]);

    function getUsers() {
        Axios.get(`/admin/users?pageSize=5&page=0${searchValue && searchValue.length > 0 ? `&name=${searchValue}` : ''}`)
            .then(res => {
                setUsers(res.data);
            });
    }

    function onChange(e) {
        setTaskReg({ ...taskReg, [e.target.name]: e.target.value });
    }

    function setUser(user) {
        setTaskReg({ ...taskReg, userId: user.id, userName: user.name, userEmail: user.email });
    }

    function onDeleteClick(e) {
        if (window.confirm("Biztos, hogy törlöd a jelentkezést?\nA művelet nem visszavonható.")) {
            setIsProgress(true);
            Axios.delete(`/admin/events/${eventId}/tasks/${taskReg.taskId}/registrations/${taskReg.id}`)
                .then(res => {
                    setIsProgress(false);
                    toast.success(`A jelentkezés törölve.`);
                    window.history.back();
                }, err => {
                    setIsProgress(false);
                    toast.error("A jelentkezés törlése sikertelen volt.");
                });
        }
    }

    function onSubmit(e) {
        e.preventDefault();

        setIsProgress(true);
        Axios.post(`/admin/events/${eventId}/tasks/${taskReg.taskId}/registrations/${taskReg.id}`,
            new TaskRegistration(taskReg.id, taskReg.remark, taskReg.pointValue,
                taskReg.state, taskReg.adminRemark, taskReg.deleted,
                taskReg.taskId, taskReg.userId))
            .then(response => {
                setIsProgress(false);
                toast.success('Jelentkezés elmentve.');
                window.history.back();
            }, err => {
                console.log(err);
                setIsProgress(false);
                setError(err.errors);
                toast.error(`A jelentkezés mentése sikertelen volt. ${err.errors[''] ? err.errors[''] : ''}`);
            });
    }

    if (isProgress)
        return <ProgressIndicator />;

    if (taskReg)
        return (
            <Form onSubmit={onSubmit} id="taskRegistrationEditForm" >
                <FormGroup>
                    <FormGroup row>
                        <FormGroup className="col-md">
                            <Label for='userName'>Felhasználó</Label>
                            {!usersVisible && <Input onClick={() => { setUsersVisible(true); setSearchValue(taskReg.userName); }} invalid={error.UserId ? true : false} name='userName' value={`${taskReg.userName} (${taskReg.userEmail})`} readOnly />}
                            {usersVisible && <div className='dropDown rounded'>
                                <Input onChange={e => setSearchValue(e.target.value)} value={searchValue} name='userName' />
                                {users.map(u => <div className="item" key={uuid()} onClick={() => { setUser(u); setUsersVisible(false); }}>{u.name} ({u.email})</div>)}
                                <Button color="warning" onClick={() => setUsersVisible(false)}>Mégsem</Button>
                            </div>
                            }
                            {error.UserId && <FormFeedback>{error.UserId}</FormFeedback>}
                        </FormGroup>
                        <SelectFieldGroup className="col-lg-4"
                            field="state"
                            onChange={onChange}
                            label="Állapot"
                            error={error.State}
                            value={taskReg.state}
                        >
                            {new Array(3).fill(0).map((value, index) => {
                                return <option value={index} key={index}>{registrationStateToString(index)}</option>
                            })}
                        </SelectFieldGroup>
                    </FormGroup>
                    <FormGroup row>
                        <TextFieldGroup className="col-lg-4"
                            field="pointValue"
                            onChange={onChange}
                            label="Kapott pont"
                            type="number"
                            error={error.PointValue}
                            value={taskReg.pointValue}
                        />
                        <TextFieldGroup className="col-lg-4"
                            field="remark"
                            onChange={onChange}
                            label="Megjegyzés"
                            error={error.Remark}
                            value={taskReg.remark}
                        />
                        <TextFieldGroup className="col-lg-4"
                            field="adminRemark"
                            onChange={onChange}
                            label="Admin megjegyzés"
                            error={error.AdminRemark}
                            value={taskReg.adminRemark}
                        />
                    </FormGroup>
                </FormGroup>

                {error[""]}
                <Button color="primary" type="submit"><FontAwesomeIcon icon={faCheck} /> Mentés</Button>
                <Button color="primary" type="button" onClick={(e) => window.history.back()}><FontAwesomeIcon icon={faArrowLeft} /> Mégsem</Button>
                <Button color="warning" type="button" onClick={onDeleteClick} className="float-right"><FontAwesomeIcon icon={faTrash} /> Törlés</Button>
            </Form >
        );

    return null;
}

export default TaskRegistrationEditForm;
